import { HTMLProps } from 'react';
import { Image, ImageProps } from 'react-bootstrap';
import { BsHospital } from 'react-icons/bs';

interface FacilityLogoProps {
  imgSrc?: string;
  size?: number;
}

export const FacilityLogo = ({
  imgSrc,
  size = 30,
  className,
  style,
  ...rest
}: (FacilityLogoProps & HTMLProps<HTMLElement>) | (FacilityLogoProps & ImageProps)) => (
  <>
    {imgSrc ? (
      <Image
        src={imgSrc}
        alt="Facility Logo"
        className={`rounded object-fit-contain ${className}`}
        style={{ width: size, height: size, ...style }}
        {...(rest as ImageProps)}
      />
    ) : (
      <div
        className={`facility-logo-placeholder d-flex justify-content-center align-items-center border rounded ${className}`}
        style={{ width: size, height: size, ...style }}
        {...(rest as ImageProps)}
      >
        <BsHospital size={0.7 * size} />
      </div>
    )}
  </>
);
